import React, { useEffect, useState } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { SNETButton, AlertBox, SNETTextfield } from "shared/dist/components";
import { getAddress, initSDK } from "shared/dist/utils/snetSdk";
import { setOrgOwnerAddress } from "../../../../Services/Redux/actionCreators/organizationActions";
import classes from "./TechnicalInfo.module.css";

const MMAddress = () => {
    const { email, ownerAddress, ownerEmail } = useSelector(
        (state) => ({
            email: state.user.email,
            ownerAddress: state.organization.owner.address,
            ownerEmail: state.organization.owner.username,
        }),
        shallowEqual
    );
    const dispatch = useDispatch();
    const [connectingError, setConnectingError] = useState();
    const [address, setAddress] = useState();

    useEffect(() => {
        setAddress(ownerAddress);
    }, [ownerAddress, address]);

    const handleConnetMM = async () => {
        try {
            const sdk = await initSDK();
            const address = await getAddress(sdk);
            dispatch(setOrgOwnerAddress(address));
            setAddress(address);
        } catch (error) {
            setConnectingError(error);
        }
    };

    if (email !== ownerEmail) {
        return null;
    }

    return (
        <div className={classes.MMAddressContainer}>
            {!!address ? (
                <div className={classes.ownerAddress}>
                    <SNETTextfield
                        name="ownerAddress"
                        value={address}
                        disabled
                        label="Owner's Metamask Address"
                        error={connectingError}
                    />{" "}
                </div>
            ) : (
                <div className={classes.alert}>
                    <AlertBox
                        message="Please install or log in to Metamask to proceed further.  Learn more about Metamask."
                        type="warning"
                    />
                </div>
            )}
            <SNETButton
                color="primary"
                variant="contained"
                children="connect metamask"
                onClick={handleConnetMM}
            />
        </div>
    );
};

export default MMAddress;
